import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

/**
 * Erreurs liées à l'authentification et à la gestion des utilisateurs
 */
export const AUTH_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.WRONG_AUTH]: {
        messageKey: 'unable-to-log-you-in-please-check-your-email-and-password-or-request-account-activation',
        severity: 'warning',
    },
    [ERROR_CODES.INACTIVE_COMPANY]: {
        messageKey: 'the-company-linked-to-your-account-is-not-active-please-contact-support',
        severity: 'warning',
    },
    [ERROR_CODES.NO_LICENSE]: {
        messageKey: 'you-do-not-have-a-user-license-assigned-by-your-company-please-contact-your-administrator',
        severity: 'warning',
    },
    [ERROR_CODES.WRONG_CONFIG_COMPANY]: {
        messageKey: 'the-company-linked-to-your-account-is-not-properly-configured-please-contact-support',
        severity: 'warning',
    },
};